<template>
  <div>
    <v-card>
      <v-card-title>
        {{ $t('admissions.council_form.council_appointments') }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="$t('admissions.council_form.search')"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="assemblies"
        :search="search"
        :loading="loadingTable"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.description }}</td>
          <td class="text-xs-center">{{ assistance_types[props.item.assistance_type] }}</td>
          <td class="text-xs-center">{{ props.item.name_as }}</td>
          <td class="text-xs-center">
            <v-tooltip top v-show="others.is_external==0">
              <v-icon
                medium
                class="mr-2"
                @click="takeScheduleAssistance(props.item)"
                slot="activator"
              >
                assignment_turned_in
              </v-icon>
              <span>Ver Más</span>

            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-if="appointments"
      v-model="dialog"
      transition="dialog-transition"
    >
      <v-card>
        <assistance
          :appointments="appointments"
          :settings="settings"
        ></assistance>
        <v-layout row justify-center>
            <v-btn
            @click="dialog = false"
            color="primary">close</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
    import axios from 'axios'
    import assistance from './appointment_assistance'

    export default {
        name: 'admissions-appointments',
        components: {
          'assistance': assistance,
        },
        data() {
            return {
                others:[],
                search: '',
                headers: [
                    { text: this.$t('admissions.council_form.council_appointments'), align: 'center', value: 'description' },
                    { text: this.$t('admissions.council_form.appointment_type'), align: 'center', value: 'assistance_type' },
                    { text: this.$t('admissions.council_form.responsible'), align: 'center', value: 'name_as' },
                    { text: this.$t('admissions.council_form.action'), align: 'center', value: 'id', sortable: false }
                ],
                assemblies: [],
                settings: null,
                appointments: null,
                dialog: false,
                loadingTable: false,
                assistance_types: {
                  BOTH: 'Virtual y Presencial',
                  ONLINE: 'Virtual',
                  FACEFACE: 'Presencial'
                }
            }
        },
        created() {
            this.getShow()
        },
        methods: {
            async getShow() {
                this.loadingTable = true;
                const { data } = await axios.get('/quotes/responsable/show')
                let assemblies = data.data;
                this.others = data.others[0]

                await axios.get('/api/admissions/get_settings')
                  .then(resp => {
                    if (resp.status === 200) {
                      this.settings = resp.data[0]
                      const quotes_id = JSON.parse(this.settings.quote2_id)
                      const arrOfNum = quotes_id.map(str => {
                        return parseInt(str, 10);
                      });
                      assemblies = assemblies.filter(ass => arrOfNum.includes(ass.quotes_id));
                    }
                  })
                  .catch(error => console.log(error))

                if (data.others[0].is_external!=0) {
                  assemblies = assemblies.filter(ass => ass.status == 0);
                }
                this.assemblies = assemblies
                this.loadingTable = false;
            },
            takeScheduleAssistance(item) {
              axios.get(`/api/admissions/quote/${item.id}`)
                .then(resp => {
                  if (resp.status === 200) {
                    this.appointments = resp.data
                    this.dialog = true
                  }
                })
                .catch(error => {
                  console.log(error)
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/appointments.vue